import type { AnyFieldMeta } from '@tanstack/react-form'

// react-form v1: validators can return strings (custom) or Standard Schema
// issue objects (zod 3.24+). Normalize to a string for display.
export function normalizeFieldErrors(errors: AnyFieldMeta['errors']): string[] {
  return errors
    .map(err => {
      if (typeof err === 'string') {
        return err
      }
      if (err && typeof err === 'object' && 'message' in err) {
        return String(err.message)
      }
      return null
    })
    .filter((err): err is string => err !== null)
}

export function DisplayFieldErrors({ meta }: { meta: AnyFieldMeta }) {
  const messages = normalizeFieldErrors(meta.errors)
  if (!messages.length) {
    return null
  }
  return (
    <div className="form-control-error">
      {messages.map((message, idx) => (
        <div key={`${idx}-${message}`}>{message}</div>
      ))}
    </div>
  )
}
